import {BehaviorSubject} from "rxjs";
// import * as Sentry from '@sentry/browser';

interface IResponse {
  promise: any,
  successCallback?: any,
  errorCallback?: any,
  errorTag?: string
}
class ResponseHandlerService {
    static instance: ResponseHandlerService;
    private error$: BehaviorSubject<string>;
    private errors$: BehaviorSubject<any>;
    private success$: BehaviorSubject<string>;
    private errorStack$: BehaviorSubject<string[]>;

    constructor() {
        this.error$ = new BehaviorSubject<string>('');
        this.errors$ = new BehaviorSubject<any>({});
        this.success$ = new BehaviorSubject<string>('');
        this.errorStack$ = new BehaviorSubject<string[]>([]);
    }

    static getInstance(): ResponseHandlerService {
      if (!ResponseHandlerService.instance) {
        ResponseHandlerService.instance = new ResponseHandlerService();
      }
      return ResponseHandlerService.instance;
    }

    getError = () => this.error$;

    getErrors = () => this.errors$;

    getErrorStack = () => this.errorStack$;

    clearError = () => this.error$.next('');

    clearErrors = () => this.errors$.next({});

    emitError = (error: any, tag: string = '') => {
      this.error$.next(error);
      this.errors$.next({ [tag]: error});
      // this.errorStack$.next([...this.errorStack$.getValue(), error?.response?.data?.errors]);
    }

    getSuccess = () => this.success$;

    clearSuccess = () => this.success$.next('');

    emitSuccess = (error: any) => this.success$.next(error);

    handleResponse = ({
      promise,
      successCallback,
      errorCallback,
      errorTag
    }: IResponse) => promise.then((res: any) => {
      successCallback && successCallback(res);
      this.emitSuccess(res);
      return res;
    }).catch((err: any) => {
      console.error('%c🚫 Error: ', 'background: #a20300; color: #ffa8a6; font-size: 11px', err);
      errorCallback && errorCallback(err);
      this.emitError(err, errorTag);
      // Sentry.captureException(err);
      return err;
    })
}

export default ResponseHandlerService;
